import { render, staticRenderFns } from "./iot.vue?vue&type=template&id=31615c8a&"
import script from "./iot.vue?vue&type=script&lang=js&"
export * from "./iot.vue?vue&type=script&lang=js&"
import style0 from "./iot.vue?vue&type=style&index=0&id=31615c8a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports